export enum CaseOverviewType {
  Cases,
  Finance
}
